module.exports = __webpack_public_path__ + "img/VehiculoDatos.eb842293.svg";